(() => {
  const SELECTOR = '[data-dives-carico-allocation="true"]';

  function getVariantPlan(root) {
    const data = root.querySelector('[data-dives-carico-variants]');
    if (!data) return [];

    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      console.error('DIVES: dati varianti CARICO non validi', error);
      return [];
    }
  }

  function dispatch(root, name, detail = {}) {
    root.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail,
      }),
    );
  }

  function allocationError(root, form, message) {
    dispatch(root, 'baseline:productform:error', {
      sourceId: form.id,
      variantId: Number(form.querySelector('[name="id"]')?.value || 0),
      errors: message,
      message,
    });
  }

  async function allocateItems(variants, requestedQuantity) {
    const cartResponse = await fetch(`${window.theme.routes.root_url}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!cartResponse.ok) throw new Error('Impossibile leggere il carrello.');

    const cart = await cartResponse.json();
    const quantitiesInCart = new Map();
    for (const item of cart.items) {
      quantitiesInCart.set(
        item.variant_id,
        (quantitiesInCart.get(item.variant_id) || 0) + item.quantity,
      );
    }

    let remaining = requestedQuantity;
    const items = [];

    for (const variant of variants) {
      if (!variant.available || remaining <= 0) continue;

      const alreadyInCart = quantitiesInCart.get(variant.id) || 0;
      const capacity = variant.continueSelling
        ? remaining
        : Math.max(0, variant.inventoryQuantity - alreadyInCart);
      const quantity = Math.min(remaining, capacity);

      if (quantity > 0) {
        items.push({ id: variant.id, quantity });
        remaining -= quantity;
      }
    }

    return { items, remaining };
  }

  async function submitCaricoForm(event, form, root) {
    // In Baseline il selettore quantità è normalmente fuori dal tag <form>
    // ed è collegato ad esso con l'attributo HTML `form`. form.elements include
    // anche questi controlli associati, mentre form.querySelector non li vede.
    const quantityControl = form.elements.namedItem('quantity');
    const requestedQuantity = Math.max(
      1,
      Number.parseInt(quantityControl?.value || '1', 10),
    );
    const variants = getVariantPlan(root);

    if (!variants.length) return;

    dispatch(root, 'baseline:productform:loading');

    try {
      const { items, remaining } = await allocateItems(variants, requestedQuantity);
      if (remaining > 0) {
        const available = requestedQuantity - remaining;
        const message = available > 0
          ? `Sono disponibili soltanto ${available} bottiglie.`
          : 'Questo prodotto non è più disponibile.';
        allocationError(root, form, message);
        return;
      }

      // Alcune configurazioni Shopify/app di controllo quantità validano male
      // un'unica richiesta multi-variante dello stesso prodotto. Eseguiamo le
      // righe in sequenza: per il cliente resta un solo clic, ma lato Shopify è
      // equivalente alle aggiunte singole che il negozio accetta correttamente.
      let eventResponse = null;
      for (const item of items) {
        const response = await fetch(window.theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [item],
            sections: ['cart-items', 'cart-footer', 'cart-item-count', 'cart-live-region'],
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Impossibile aggiungere il prodotto al carrello.');
        }

        const addedItem = Array.isArray(data.items) ? data.items[0] : null;
        eventResponse = addedItem
          ? {
              ...data,
              key: addedItem.key,
              variant_id: addedItem.variant_id,
            }
          : data;
      }

      dispatch(root, 'baseline:productform:success');
      document.body.dispatchEvent(
        new CustomEvent('baseline:cart:afteradditem', {
          bubbles: true,
          detail: {
            response: eventResponse,
            sourceId: form.id,
          },
        }),
      );
    } catch (error) {
      allocationError(root, form, error.message || 'Si è verificato un errore durante l’aggiunta al carrello.');
    }
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.divesCaricoForm !== 'true') return;

      const root = form.closest(SELECTOR)
        || form.closest('data-island[x-data="ProductForm"]');
      if (!root) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      submitCaricoForm(event, form, root);
    },
    true,
  );
})();
